export const renderAddressLines = (lines: string[] = []) =>
  lines[0] && lines[1] ? lines.join(', ') : lines[0] || '';
